import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { gamificationService } from '../services/api';
import { useAuth } from './AuthContext';

const GamificationContext = createContext(null);

/**
 * Nível e XP do curso atual para a barra superior. Fica fora das páginas para que, ao navegar,
 * o valor anterior continue na tela enquanto o novo chega (a barra anima de um para o outro).
 */
export function GamificationProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({ slug: null, summary: null });

  // Outro usuário: não reaproveita o nível de quem saiu
  useEffect(() => { setState({ slug: null, summary: null }); }, [user?.id]);

  const refresh = useCallback(async (slug) => {
    if (!slug) return;
    try {
      const summary = await gamificationService.getSummary(slug);
      setState({ slug, summary });
    } catch {
      // Sem XP na barra não impede o uso da página
    }
  }, []);

  const value = useMemo(() => ({ ...state, refresh }), [state, refresh]);
  return <GamificationContext.Provider value={value}>{children}</GamificationContext.Provider>;
}

export function useGamification() {
  return useContext(GamificationContext);
}
